import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";

import RadioGroup, { RadioSelectOption } from "features/components/RadioGroup";

import { ChartTimeGrouping } from "./types";

export interface TimeGroupingMenuItemProps {
  chartLabel?: string;
  chartTimeGrouping?: ChartTimeGrouping;
  onChartTimeGroupingChange?: (value: ChartTimeGrouping) => void;
  hideMenu?: () => void;
}

const TimeGroupingMenuItem = ({
  chartLabel,
  chartTimeGrouping,
  onChartTimeGroupingChange,
  hideMenu,
}: TimeGroupingMenuItemProps) => {
  const { t } = useTranslation();

  const timeGroupingOptions: RadioSelectOption[] = [
    { id: "day", value: t("schema:dashboard.granularity_day") },
    { id: "week", value: t("schema:dashboard.granularity_week") },
  ];

  const handleTimeGroupingChange = (value: string) => {
    if (onChartTimeGroupingChange) {
      onChartTimeGroupingChange(value as ChartTimeGrouping);
    }

    if (hideMenu) {
      hideMenu();
    }
  };

  return (
    <div className="flex flex-col text-sm!">
      <div className="px-3 pb-3">
        <div className="text-sm font-medium mb-3 text-gray-700">
          {t("schema:dashboard.column_settings")}
        </div>
        <div className="text-sm mb-2 pb-2 border-b border-gray-300 text-gray-600">
          {t("schema:dashboard.show_title_by", { title: chartLabel })}
        </div>
        <Box
          sx={{
            "& .MuiFormControlLabel-root": {
              gap: "11px",
            },
          }}
          className="px-2"
        >
          <RadioGroup
            options={timeGroupingOptions}
            selected={chartTimeGrouping}
            onSelect={handleTimeGroupingChange}
          />
        </Box>
      </div>
    </div>
  );
};

export default TimeGroupingMenuItem;
